export type AlarmChartDataType = 'current' | 'voltage' | 'temperature' | 'door_open'

export const ALARM_CHART_TYPE_MAP: Record<string, AlarmChartDataType> = {
  interruption: 'current',
  low_load: 'current',
  power_factor: 'current',
  activation_peak_hour: 'current',
  empty_mixer: 'current',
  outside_regular_time: 'current',
  burnt_resistor: 'current',
  defrost_time: 'current',
  no_data: 'current',
  overvoltage: 'voltage',
  critical_temperature: 'temperature',
  door_open: 'door_open',
}